'use strict';

exports.__esModule = true;
exports['default'] = math;

var _defaultMathSymbols = /*#__PURE__*/ _interopRequireDefault(
    /*#__PURE__*/ require('./defaultMathSymbols')
);

var _errors = /*#__PURE__*/ _interopRequireDefault(
    /*#__PURE__*/ require('../internalHelpers/_errors')
);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _extends() {
    _extends =
        Object.assign ||
        function (target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        };
    return _extends.apply(this, arguments);
}

var unitRegExp =
    /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g; // Merges additional math functionality into the defaults.

function mergeSymbolMaps(additionalSymbols) {
    var symbolMap = {};
    symbolMap.symbols = additionalSymbols
        ? _extends({}, _defaultMathSymbols['default'].symbols, additionalSymbols.symbols)
        : _extends({}, _defaultMathSymbols['default'].symbols);
    return symbolMap;
}

function exec(operators, values) {
    var _ref;

    var op = operators.pop();
    values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
    return op.precedence;
}

function calculate(expression, additionalSymbols) {
    var symbolMap = mergeSymbolMaps(additionalSymbols);
    var match;
    var operators = [symbolMap.symbols['('].prefix];
    var values = [];
    var pattern = new RegExp( // Pattern for numbers
        '\\d+(?:\\.\\d+)?|' + // ...and patterns for individual operators/function names
            Object.keys(symbolMap.symbols)
                .map(function (key) {
                    return symbolMap.symbols[key];
                }) // longer symbols should be listed first
                // $FlowFixMe
                .sort(function (a, b) {
                    return b.symbol.length - a.symbol.length;
                }) // $FlowFixMe
                .map(function (val) {
                    return val.regSymbol;
                })
                .join('|') +
            '|(\\S)',
        'g'
    );
    pattern.lastIndex = 0; // Reset regular expression object

    var afterValue = false;

    do {
        match = pattern.exec(expression);

        var _ref2 = match || [')', undefined],
            token = _ref2[0],
            bad = _ref2[1];

        var notNumber = symbolMap.symbols[token];
        var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
        var notAfterValue = !notNumber || (!notNumber.postfix && !notNumber.infix); // Check for syntax errors:

        if (bad || (afterValue ? notAfterValue : notNewValue)) {
            throw new _errors['default'](37, match ? match.index : expression.length, expression);
        }

        if (afterValue) {
            // We either have an infix or postfix operator (they should be mutually exclusive)
            var curr = notNumber.postfix || notNumber.infix;

            do {
                var prev = operators[operators.length - 1];
                if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break; // Apply previous operator, since it has precedence over current one
            } while (exec(operators, values)); // Exit loop after executing an opening parenthesis or function

            afterValue = curr.notation === 'postfix';

            if (curr.symbol !== ')') {
                operators.push(curr); // Postfix always has precedence over any operator that follows after it

                if (afterValue) exec(operators, values);
            }
        } else if (notNumber) {
            // prefix operator or function
            operators.push(notNumber.prefix || notNumber.func);

            if (notNumber.func) {
                // Require an opening parenthesis
                match = pattern.exec(expression);

                if (!match || match[0] !== '(') {
                    throw new _errors['default'](
                        38,
                        match ? match.index : expression.length,
                        expression
                    );
                }
            }
        } else {
            // number
            values.push(+token);
            afterValue = true;
        }
    } while (match && operators.length);

    if (operators.length) {
        throw new _errors['default'](39, match ? match.index : expression.length, expression);
    } else if (match) {
        throw new _errors['default'](40, match ? match.index : expression.length, expression);
    } else {
        return values.pop();
    }
}

function reverseString(str) {
    return str.split('').reverse().join('');
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */

function math(formula, additionalSymbols) {
    var reversedFormula = reverseString(formula);
    var formulaMatch = reversedFormula.match(unitRegExp); // Check that all units are the same

    if (
        formulaMatch &&
        !formulaMatch.every(function (unit) {
            return unit === formulaMatch[0];
        })
    ) {
        throw new _errors['default'](41);
    }

    var cleanFormula = reverseString(reversedFormula.replace(unitRegExp, ''));
    return (
        '' +
        calculate(cleanFormula, additionalSymbols) +
        (formulaMatch ? reverseString(formulaMatch[0]) : '')
    );
}

module.exports = exports.default;
